// extracted by mini-css-extract-plugin
export default {"overlay":"Pv-z","bodyOpen":"Qv-z","content":"Rv-z","header":"Sv-z","close":"Tv-z","closeNoHeading":"Uv-z"};